import { useDebounce } from '@ipfabric/ui-components/hooks/useDebounce';
import type { FormikProps } from 'formik';
import { useEffectOnChange } from 'utils/react/useEffectOnChange';

/**
 * Auto submits form on values change
 */
export const useAutoSubmit = <TFormikValues,>(
  formik: FormikProps<TFormikValues>,
  debounceInterval: number,
): void => {
  const debounce = useDebounce(debounceInterval);

  useEffectOnChange(() => {
    debounce(() => {
      formik.handleSubmit();
    });
  }, [formik.values]);
};
